export const ActiveTabEnum = {
    ACTIVE: "active",
    EXPIRED: "expired",
};
